import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageTenerife = props => {
  return <CityLandingPage cityKey="Tenerife" cityConfig={cityContent.tenerife} {...props} />;
};

export default LandingPageTenerife;
